export const UrlParamNames = {
    TrainingContractAccessCode: "trainingContractAccessCode",
};
